import cv from '../cv.js';
import { Card, Tabs, Box } from 'dracula-ui'; 
import { createWorkTab, createEducationTab, createTalksTab, createProjectsTab } from './Tabs.js';

// Handle tabs switch
function handleTabsHighlight(e) {
  // toggle navs
  var activeTabs = document.getElementsByClassName('drac-tab drac-tab-active');
  for (let tab of activeTabs) {
    tab.classList.remove('drac-tab-active');
  }
  e.target.parentNode.classList.add('drac-tab-active');

  // toggle tab content
  var allTabsContent = document.getElementsByClassName('tab-pane');
  for (let content of allTabsContent) {
    content.style.display = "none";
  }
  var tabContent = document.getElementById(e.target.dataset.tab);
  tabContent.style.display = "block";
}

const tabs = ['work', 'education', 'talks', 'projects'];
// Mapping to call the right tab function in tabContent
const tabFunc = {
  'work': createWorkTab,
  'education': createEducationTab,
  'talks': createTalksTab,
  'projects': createProjectsTab
}

function buildNavs() {
  return(
    tabs.map((item, index) => {
      // Only highlight first tab at start
      var isActive = index === 0 ? true: false;
      var tabClass;
      if (isActive) {
        tabClass = 'drac-tab drac-tab-active';
      } else {
        tabClass = 'drac-tab';
      }
      return(
        <li key={index} className={tabClass} onClick={handleTabsHighlight}>
          <a className="drac-tab-link drac-text" href='#' data-tab={item}>
            {item.toUpperCase()}
          </a>
        </li>
      )
    })
  )
}

function tabContent() {
  return(
    <Box className="tab-content drac-text-white" scrollbar="cyan" height="3xl">
      {tabs.map((item, index) => {
        var isActive = index === 0 ? true: false;
        var toDisplay;
        if (isActive) {
          toDisplay = 'block';
        } else {
          toDisplay = 'none';
        }
        return(
          <Box 
            key={index} 
            display={toDisplay} 
            className="tab-pane" 
            m="md"
            id={item}>
            {tabFunc[item](cv[item])}
          </Box>
        )
      })}
    </Box>
  )
}

function Main() {
  return(
    <Card 
      variant="subtle"
      p="sm" 
      m="xs" 
      className="drac-border-white">
        <Tabs>
         {buildNavs()}
        </Tabs>
        {tabContent()}
    </Card>
  );
}

export default Main;